import { render, staticRenderFns } from "./AdvantagesSection.vue?vue&type=template&id=5ea2f941&scoped=true&"
import script from "./AdvantagesSection.vue?vue&type=script&lang=js&"
export * from "./AdvantagesSection.vue?vue&type=script&lang=js&"
import style0 from "./AdvantagesSection.vue?vue&type=style&index=0&id=5ea2f941&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea2f941",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
